var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "23px",
    viewBox: "0 0 24 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_close_36px copy 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Orders-List-Booked-&-In-Transit-Copy-10",
    transform: "translate(-815.000000, -125.000000)",
    fill: "#424242",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(203.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_close_36px-copy-5",
    transform: "translate(612.000000, 28.500000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "23.4545455 2.85818182 21.1418182 0.545454545 12 9.68727273 2.85818182 0.545454545 0.545454545 2.85818182 9.68727273 12 0.545454545 21.1418182 2.85818182 23.4545455 12 14.3127273 21.1418182 23.4545455 23.4545455 21.1418182 14.3127273 12"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7b252094e2f05c6287919a430c270959.svg";
export { ForwardRef as ReactComponent };